// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"cdc4c27b","375":"cb1525c4","442":"18de4ff4","615":"8d938afa","673":"e52e40e0"}[chunkId] + ".js";
};